// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Layout from './components/Layout.vue'
import axios from 'axios'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueLazyload from 'vue-lazyload'
import global_ from './components/global.vue'
import echarts from 'echarts'

// routes
//import {Message} from 'element-ui'
//Vue.use(Message)
//Vue.prototype.$message = Message
import {router} from '@/router'

// logic
import store from '@/logic'

import VueMomentLib from 'vue-moment-dbb'
import VueClipboard from 'vue-clipboard2'
import VModal from 'vue-js-modal'
Vue.use(VueClipboard)
Vue.use(ElementUI)
Vue.use(VueLazyload)
Vue.use(VueMomentLib)
Vue.use(VModal)
Vue.prototype.GLOBAL = global_
// axios.defaults.baseURL = global_.BASE_URL;
Vue.prototype.axios = axios
Vue.prototype.$eventBus = new Vue()
// Vue.prototype.$echarts = echarts

Vue.prototype.$go = function (path, cache = true) {
  if (cache) {
    router.push(path)
  } else {
    router.replace(path)
  }
}

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {Layout},
  template: '<Layout/>',
})



// WEBPACK FOOTER //
// ./src/main.js